import { Chip, tooltipClasses } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { createElement } from "react";
import { useTranslation } from "react-i18next";
import { TbUserScan } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { UserTypeItem, userTypes } from "@/constants/userTypes";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import { User, UserType } from "@/types/user.types";

export function RenderUserTypeCellTooltip({ status }: { status: UserTypeItem }) {
    const { t } = useTranslation();
    return (
        <NoMaxWidthTooltip
            arrow
            sx={{
                [`& .${tooltipClasses.tooltip}`]: {
                    backgroundColor: "white",
                    border: "none",
                    padding: "0px !important",
                    fontSize: 12,
                    maxWidth: "200px !important",
                },
            }}
            title={<HotelStatusTooltip status={status} />}
        >
            <Chip
                sx={{
                    backgroundColor: status.bg,
                    color: status.text,
                    fontWeight: 500,
                    fontSize: "12px !important",
                }}
                icon={createElement(status.component(), {
                    fontSize: 14,
                    color: status.text,
                })}
                label={t(status.getLabel(status.value) || "")}
            />
        </NoMaxWidthTooltip>
    );
}

export function RenderUserTypeCell({ value }: { value: UserType }) {
    const status =
        userTypes.find((status) => status.value === value) || userTypes.find((status) => status.values.includes(value));
    return (
        <div className="flex items-center py-1 h-full">{status && <RenderUserTypeCellTooltip status={status} />}</div>
    );
}

export const UserTypeColumn = ({ t }: { t: TFunction }): GridColDef<User> => {
    return {
        field: "userType",
        headerName: t("userType"),
        minWidth: 140,
        valueGetter: (_val, row) => row.userType,
        renderHeader: (params) => <TableHeader Component={TbUserScan} title={params.colDef.headerName!} />,
        renderCell: ({ value }) => <RenderUserTypeCell value={value} />,
    };
};
export default UserTypeColumn;
